import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { useAxiosLoader } from './plugins/axios'
import LoadingOverlay from 'react-loading-overlay-ts';
import BeatLoader from 'react-spinners/BeatLoader';
import { HashRouter } from 'react-router-dom';
import { hotjar } from 'react-hotjar';
import { HotjarId } from './constants/provider/constant';

const GlobalLoader = () => {
  const [loading] = useAxiosLoader();
  useEffect(() => {
    hotjar.initialize(HotjarId,6)
  },[])
  return(
    <React.StrictMode>
      <LoadingOverlay active={loading} spinner={<BeatLoader color={'#042e43'}/>} styles={
          {
            overlay: (base) => ({
            ...base,
            height:'100%',
            background: 'rgba(211,211,211, 0.5)' })
          }
        }>
        <App />
      </LoadingOverlay>
    </React.StrictMode>
  );
}

ReactDOM.render(
  <HashRouter>
    <GlobalLoader />
  </HashRouter>,
  document.getElementById('root')
);

